// WhatsApp support channel — the one place the number lives.
//
// SCRAPE RESISTANCE IS THE CONTRACT HERE. The founder runs support on a
// personal number, accepted on the explicit condition that the site never
// hands it to harvesters. Three rules, all load-bearing:
//
//   1. The digits are stored as char codes, never as a literal. Harvesters
//      grep served assets for phone patterns (\d{10,}) and wa.me/<digits>
//      URLs; neither pattern exists in this bundle.
//   2. No wa.me href ever sits in the DOM. Every entry point is a <button>
//      and the URL is assembled inside the click handler, then opened.
//      View-source, crawlers, and static DOM scrapes see nothing.
//   3. Nothing here renders the number as text. Customers see it only
//      inside WhatsApp itself after the chat opens — that exposure is the
//      accepted cost of the personal-number decision, the rest is not.
//
// To change the number later (the Change Number escape hatch):
//   node -e "console.log([...'1XXXXXXXXXX'].map(c => c.charCodeAt(0)))"
// and replace NUM_CODES. Empty array = feature fully dormant, every
// placement renders nothing.
import { track } from '../api/track'

const NUM_CODES = [49, 54, 51, 49, 51, 55, 55, 57, 50, 50, 55]

export function whatsappEnabled(): boolean {
  return NUM_CODES.length > 0
}

/** Assemble the wa.me URL and open the chat. `placement` feeds the
 *  cta_clicked event so the funnel can tell which surface earns its keep. */
export function openWhatsApp(prefill: string, placement: string): void {
  if (!whatsappEnabled()) return
  track('cta_clicked', { element: 'whatsapp', placement })
  const num = String.fromCharCode(...NUM_CODES)
  const url = `https://wa.me/${num}?text=${encodeURIComponent(prefill)}`
  window.open(url, '_blank', 'noopener,noreferrer')
}
